import { Legislation } from "../models";
import { parseChapter, processDocumentText } from "./index";

interface BuildLegislationPrintHTMLProps {
  legislation: Legislation;
  hideRevoked: boolean;
}

export const buildLegislationPrintHTML = ({
  legislation,
  hideRevoked,
}: BuildLegislationPrintHTMLProps) => {
  if (!legislation) return "";

  const nicknames =
    legislation.apelidos?.filter((name: string) => name !== legislation.nome) ||
    [];

  let mainText = "";
  if (legislation.texto) {
    const processed = processDocumentText({
      htmlText: `
        ${
          nicknames.length
            ? `<p class="nicknames">${nicknames.join(" - ")}</p>`
            : ""
        }
        ${legislation.texto}
      `,
      hideRevoked,
    });

    mainText = processed;
  }

  const articlesHTML = (legislation.artigos || [])
    .map((art, index) => {
      const prev = legislation.artigos[index - 1];

      const showBook = !prev || prev.livro !== art.livro;
      const showTitle = !prev || prev.titulo !== art.titulo;
      const showChapter = !prev || prev.capitulo !== art.capitulo;
      const showSecao = !prev || prev.secao !== art.secao;

      const parts: string[] = [];

      if (showBook && art.livro) {
        parts.push(`
          <div class="article-title-box">
            <p class="article-chapter">
              ${art.livro.replace(" - ", "<br/>")}
            </p>
          </div>
        `);
      }

      if (showTitle && art.titulo) {
        parts.push(`
          <div class="article-title-box">
            <p class="article-chapter">
              ${art.titulo.replace(" - ", "<br/>")}
            </p>
          </div>
        `);
      }

      if (showChapter && art.capitulo) {
        const { title, notes } = parseChapter(art.capitulo);

        parts.push(`
          <div class="article-title-box">
            <p class="article-chapter">
              ${String(title).replace(" - ", "<br/>")}
            </p>
            ${notes ? `<div class="content-text">${notes}</div>` : ""}
          </div>
        `);
      }

      if (showSecao && art.secao) {
        parts.push(`
          <div class="article-title-box">
            <p class="article-chapter">
              ${art.secao.replace(" - ", "<br/>")}
            </p>
          </div>
        `);
      }

      const processedArticle = processDocumentText({
        htmlText: art.texto,
        hideRevoked,
      });

      parts.push(`
        <div class="content-text">
          ${processedArticle}
        </div>
      `);

      return `<div class="article-item">${parts.join("")}</div>`;
    })
    .join("");

  return ` <div class="print-legislation">
    <div class="legislation">
      <div class="content-text">${mainText}</div>
    </div>
    <div class="articles">${articlesHTML}</div>
  </div>`;
};

interface PrintLegislationProps {
  legislation: any;
  hideRevoked: boolean;
}

export const printLegislationContent = ({
  legislation,
  hideRevoked,
}: PrintLegislationProps) => {
  const html = buildLegislationPrintHTML({
    legislation,
    hideRevoked,
  });

  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>${legislation?.titulo || "Legislação"}</title>
        <link rel="stylesheet" href="/print.css" />
      </head>
      <body>
        ${html}
        <script>
          window.onload = function () {
            window.print();
          };
          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};
